import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const SkeletonBase = styled.div<{ height?: string }>`
  background: rgb(215, 216, 206);
  background-image: linear-gradient(
    to right,
    rgb(215, 216, 206) 0%,
    rgb(200, 201, 190) 20%,
    rgb(215, 216, 206) 40%,
    rgb(215, 216, 206) 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 104px;
  border-radius: 4px;
  height: ${props => props.height || '1rem'};
  position: relative;
  animation: ${shimmer} 1.5s infinite linear;
`;

export const Skeleton = {
  Text: styled(SkeletonBase)`
    width: 100%;
  `,
  Button: styled(SkeletonBase)`
    width: 200px;
    margin: 1rem auto;
  `
};
